import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  Table,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Alert,
  InputGroup,
  FormControl,
  OverlayTrigger,
  Tooltip,
  ButtonGroup,
} from "react-bootstrap";
import {
  FaCheck,
  FaTimes,
  FaPlus,
  FaDollarSign,
  FaArrowRight,
  FaAddressBook
} from "react-icons/fa";
import axios from "axios";
import "./ToggleSwitch.css";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext"; // Importa el contexto de autenticación
import api from "../../services/axiosConfig";
import CampoCelular from "../common/CampoCelular";
import { validarCelular } from "../../utils/telefono";
import Tippy from '@tippyjs/react';



const ToggleSwitch = ({ id, checked, onChange }) => {
  return (
    <label className="switch">
      <input type="checkbox" id={id} checked={!checked} onChange={onChange} />
      <span className="slider round"></span>
    </label>
  );
};


const ManageSellers = () => {
  const [users, setUsers] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [nombres_apellidos, setNombresApellidos] = useState("");
  const [password, setPassword] = useState("");
  const [paisCelular, setPaisCelular] = useState("MX");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [showSaldoModal, setShowSaldoModal] = useState(false);
  const [valor, setValor] = useState("");
  const [porcentaje, setPorcentaje] = useState(4);
  const navigate = useNavigate();
  const [actingAsSeller, setActingAsSeller] = useState(false);
  const { updateUserRole } = useContext(AuthContext);
  const [editingSaldoIndex, setEditingSaldoIndex] = useState(null);
  const [editableSaldoValue, setEditableSaldoValue] = useState("");

  const [editableValue, setEditableValue] = useState("");
  const [editType, setEditType] = useState("");
  const inputRef = useRef(null);
  const containerRef = useRef(null);

  const [emailError, setEmailError] = useState("");
  const [nameError, setNameError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  

  
  // Nuevas variables de estado para los campos editables
  const [editedEmail, setEditedEmail] = useState("");
  const [editedUsuarioPorcentaje, setEditedUsuarioPorcentaje] = useState("");
  const [editedPorcentaje, setEditedPorcentaje] = useState("");
  const [usuarioPorcentajeError, setUsuarioPorcentajeError] = useState("");
  const [porcentajeError, setPorcentajeError] = useState("");

  const [isProcessing, setIsProcessing] = useState(false);

  const [userToDelete, setUserToDelete] = useState(null);
  





  const [showSuccessModal, setShowSuccessModal] = useState(false); // Para el modal de éxito
  const [modalMessage, setModalMessage] = useState(""); // El mensaje que se mostrará en el modal
 
  const [sortedField, setSortedField] = useState({
    field: null,
    direction: "asc",
  });
    // Función para mostrar el modal de éxito
    const showSuccessMessage = (message) => {
      setModalMessage(message);
      setShowSuccessModal(true);
      setTimeout(() => {
        setShowSuccessModal(false); // Cerrar el modal después de 2 segundos
      }, 2000);
    };



  // Validación de email
  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };

  // Efecto para actualizar los campos cuando se selecciona un usuario
  useEffect(() => {
    if (selectedUser) {
      setEditedEmail(selectedUser.usuario.correo);
      setEditedUsuarioPorcentaje(selectedUser.usuario.porcentaje);
      setEditedPorcentaje(selectedUser.porcentaje);
    }
  }, [selectedUser]);

  // Manejo de cambios y validaciones en tiempo real
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEditedEmail(value);

    if (validateEmail(value)) {
      setEmailError("");
    } else {
      setEmailError("El correo electrónico no es válido");
    }
  };

  const handleUsuarioPorcentajeChange = (e) => {
    const value = e.target.value;
    setEditedUsuarioPorcentaje(value);

    const numValue = parseFloat(value);
    if (isNaN(numValue) || numValue < 0 || numValue > 2) {
      setUsuarioPorcentajeError("El porcentaje debe estar entre 0 y 2");
    } else {
      setUsuarioPorcentajeError("");
    }
  };

  const handlePorcentajeChange = (e) => {
    const value = e.target.value;
    setEditedPorcentaje(value);

    const numValue = parseFloat(value);
    if (isNaN(numValue) || numValue < 0 || numValue > 7) {
      setPorcentajeError("El porcentaje debe estar entre 0 y 7");
    } else {
      setPorcentajeError("");
    }
  };

  // Métodos para enviar los datos al backend
  const handleEmailSubmit = async () => {
    if (emailError) {
      return;
    }
    const token = localStorage.getItem("token");
    try {
      await api.put(
        `/admin/editar-correo/${selectedUser.usuario.id}`,
        {
          correo: editedEmail,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setMessage({ type: "success", text: "Correo actualizado exitosamente" });
      setSelectedUser((prev) => ({
        ...prev,
        usuario: {
          ...prev.usuario,
          correo: editedEmail,
        },
      }));
      fetchUsers();
    } catch (error) {
      setMessage({ type: "error", text: "No se pudo actualizar el correo" });
      console.error("Error al actualizar el correo", error);
    }
  };

  const handleUsuarioPorcentajeSubmit = async () => {
    if (usuarioPorcentajeError) {
      return;
    }
    const token = localStorage.getItem("token");
    try {
      await api.post(
        `/admin/actualizar-porcentaje-usuario`,
        {
          usuarioId: selectedUser.usuario.id,
          porcentaje: parseFloat(editedUsuarioPorcentaje),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setMessage({
        type: "success",
        text: "Porcentaje del usuario actualizado exitosamente",
      });
      setSelectedUser((prev) => ({
        ...prev,
        usuario: {
          ...prev.usuario,
          porcentaje: parseFloat(editedUsuarioPorcentaje),
        },
      }));
    } catch (error) {
      setMessage({
        type: "error",
        text: "No se pudo actualizar el porcentaje del usuario",
      });
      console.error("Error al actualizar el porcentaje del usuario", error);
    }
  };

  const handlePorcentajeSubmit = async () => {
    if (porcentajeError) {
      return;
    }
    const token = localStorage.getItem("token");
    try {
      await api.post(
        `/admin/actualizar-porcentaje`,
        {
          tiendaId: selectedUser.id,
          porcentaje: parseFloat(editedPorcentaje),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setMessage({
        type: "success",
        text: "Porcentaje actualizado exitosamente",
      });
      setSelectedUser((prev) => ({
        ...prev,
        porcentaje: parseFloat(editedPorcentaje),
      }));
    } catch (error) {
      setMessage({
        type: "error",
        text: "No se pudo actualizar el porcentaje",
      });
      console.error("Error al actualizar el porcentaje", error);
    }
  };

const validateName = (name) => {
  const soloLetrasYEspacios = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ ]*$/;
  const sinSecuenciaLarga = !/\S{16,}/.test(name); // No debe haber más de 15 caracteres sin espacio
  return name.length <= 40 && soloLetrasYEspacios.test(name) && sinSecuenciaLarga;
};


  

  // Validar el formulario en tiempo real
  const [formIsValid, setFormIsValid] = useState(false);

  // Fetch users and geolocation on component mount
  useEffect(() => {
    fetchUsers();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (error) => {
          console.error("Error al obtener la geolocalización", error);
        }
      );
    }
  }, []);

  // Fetch users from backend
  const fetchUsers = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await api.get("/admin/obtener-vendedor", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUsers(response.data);
    } catch (error) {
      console.error("Error al obtener los usuarios", error);
    }
  };

  // Handle saldo editing
  const handleSaldoClick = (index) => {
    setEditingSaldoIndex(index);
    setEditableSaldoValue("");
  };
  const handleSaldoChange = (e) => {
    let value = e.target.value;
  
    // Permite solo un "-" al inicio
    value = value.replace(/(?!^)-/g, '');
  
    // Permite solo un "."
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('').replace(/\./g, '');
    }
  
    // Limita a dos decimales
    value = value.replace(/^(-?\d*\.\d{2}).*$/, '$1');
  
    // Permite solo números, un "-" al inicio y un solo "."
    if (!/^(-?\d+(\.\d{0,2})?)?$/.test(value)) {
      value = value.replace(/[^0-9.-]/g, '');
    }
  
    e.target.value = value;
    setEditableSaldoValue(e.target.value);
  };
  


  const handleSaldoBlur = async (user) => {
    if (isProcessing) return; // Evitar llamadas repetidas
    setIsProcessing(true);
    if (editableSaldoValue.trim() === "") {
      setEditingSaldoIndex(null);
      return;
    }
  
    const token = localStorage.getItem("token");
    try {
      const response = await api.post(
        `/admin/acreditar-saldo2/${user.usuario.id}`,
        {
          valor: parseFloat(editableSaldoValue),
          porcentaje: 4,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      // Suponiendo que la API devuelve el saldo actualizado en response.data.saldoTotal
      const saldoTotal = response.data.saldoTotal;
      const descimal= saldoTotal.toFixed(2);
      if (parseFloat(editableSaldoValue) > 0) {
        showSuccessMessage(`${descimal} acreditado correctamente`);
      } else {
        showSuccessMessage(`${descimal} descontado correctamente`);
      }
  
      setMessage({ type: "success", text: "Saldo actualizado exitosamente" });
      setEditingSaldoIndex(null);
      fetchUsers();
    } catch (error) {
      setMessage({ type: "error", text: "No se pudo actualizar el saldo" });
      console.error("Error al actualizar el saldo", error);
      setEditingSaldoIndex(null);
    } finally {
      setIsProcessing(false);
    }
  };
  

  const handleSaldoKeyDown = (e, user) => {
    if (e.key === "Enter" && !isProcessing) {
      handleSaldoBlur(user);
    }
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  // Toggle active state
  const handleToggle = async (index, field) => {
    const token = localStorage.getItem("token");
    const user = users[index];
    const previousState = { ...user };
    try {
      user.usuario[field] = !user.usuario[field];
      setUsers([...users]);
      await api.put(
        `/admin/editar-tienda2/${user.usuario.id}`,
        {
          [field]: user.usuario[field],
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setMessage({
        type: "success",
        text: `El campo ${field} ha sido actualizado`,
      });
    } catch (error) {
      setUsers((prevUsers) => {
        prevUsers[index] = previousState;
        return [...prevUsers];
      });
      setMessage({
        type: "error",
        text: `No se pudo actualizar el campo ${field}`,
      });
      console.error(`Error al actualizar el campo ${field}`, error);
    }
  };

  // Handle editing of deposit and recharge values
  const handleEditClick = (index, type) => {
    setEditingIndex(index);
    setEditType(type);
    setEditableValue("");
  };

  const handleValueChange = (e) => {
    let value = e.target.value;
  
    // Permite solo un "-" al inicio
    value = value.replace(/(?!^)-/g, '');
  
    // Permite solo un "."
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('').replace(/\./g, '');
    }
  
    // Limita a dos decimales
    value = value.replace(/^(-?\d*\.\d{2}).*$/, '$1');
  
    // Permite solo números, un "-" al inicio y un solo "."
    if (!/^(-?\d+(\.\d{0,2})?)?$/.test(value)) {
      value = value.replace(/[^0-9.-]/g, '');
    }
  
    e.target.value = value;
    setEditableValue(value);
  };
  
  const handleRowClick = (event, rowIndex) => {
    // Verifica si el clic fue dentro de una celda editable
    if (editingIndex !== null && editingIndex !== rowIndex) {
      // Si se hace clic en otra celda o fuera del campo de edición, restaura la vista predeterminada
      setEditingIndex(null);
      setEditingSaldoIndex(null);
      setEditableValue("");
      setEditableSaldoValue("");
    }
  };

  const handleValueKeyDown = (e, user) => {
    if (e.key === "Enter" && !isProcessing) {
      handleValueSubmit(user);
    }
  };

  const handleValueSubmit = async (user) => {
    if (isProcessing) return; // Evitar llamadas repetidas
    setIsProcessing(true);

    const token = localStorage.getItem("token");

    if (editableValue.trim() === "") {
      setEditingIndex(null);
      return;
    }

    console.log("Entrando a value");

    const valor = parseFloat(editableValue);
    if (!isNaN(valor)) {
      try {
        let response;

        if (editType === "Deposito") {
          // API para Depósitos
          response = await api.post(
            `/admin/pago-vendedor/${user.usuario.correo}`,
            {
              valor: valor,
              tipo: "Deposito",
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        } else if (editType === "Recarga") {
          // API para Recargas
          response = await api.post(
            `/admin/acreditar-saldo2/${user.usuario.id}`,
            {
              valor: valor,
              credito: true,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        }
        if (valor > 0) {
          showSuccessMessage(`${valor} acreditado correctamente`); // Mostrar modal de éxito
        } else {
          showSuccessMessage(`${valor} descontados correctamente`); // Mostrar modal de éxito
        }

        setMessage({ type: "success", text: response.data.mensaje });
        setEditingIndex(null);
        fetchUsers();
      } catch (error) {
        setMessage({ type: "error", text: "No se pudo procesar la operación" });
        console.error("Error al procesar la operación", error);
      } finally {
        setIsProcessing(false); // Liberar bloqueo
      }
    }
  };


   // useEffect para limpiar el mensaje después de 3 segundos
   useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const handleShowSaldoModal = (user) => {
    setSelectedUser(user);
    setShowSaldoModal(true);
  };

  const handleCloseSaldoModal = () => {
    setSelectedUser(null);
    setShowSaldoModal(false);
  };

  const handleAcreditarSaldo = async () => {
    const token = localStorage.getItem("token");

    try {
      await api.post(
        `/admin/acreditar-saldo2/${selectedUser.usuario.id}`,
        {
          valor: parseFloat(valor),
          porcentaje: parseFloat(porcentaje),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setShowSaldoModal(false);
      fetchUsers();
    } catch (error) {
      setMessage({ type: "error", text: "No se pudo acreditar el saldo" });
      console.error("Error al acreditar el saldo", error);
    }
  };

  useEffect(() => {
    if (
      email &&
      nombres_apellidos &&
      phoneNumber &&
      !emailError &&
      !nameError &&
      !phoneError
    ) {
      setFormIsValid(true);
    } else {
      setFormIsValid(false);
    }
  }, [
    email,
    nombres_apellidos,
    phoneNumber,
    emailError,
    nameError,
    phoneError,
  ]);

  const handleCreateUser = async () => {
    const token = localStorage.getItem("token");

    // Validación del celular según el país seleccionado
    const valido = validarCelular(phoneNumber, paisCelular);
    if (!valido) {
      setPhoneError("El número no es válido para el país seleccionado.");
      return;
    }
    if (!validateEmail(email)) {
      setEmailError("El Email debe ser válido");
      return;
    }

    // Limpiar errores previos
    setEmailError("");
    setNameError("");
    setPhoneError("");
    setMessage({ type: "", text: "" });

    if (latitude && longitude) {
      try {
        await api.post(
          "/admin/crear-vendedor",
          {
            correo: email,
            // El backend calcula la contraseña; se envía por compatibilidad
            contrasenia: valido.nacional,
            celular: valido.e164,
            pais: paisCelular,
            nombres_apellidos: nombres_apellidos,
            latitud: latitude,
            longitud: longitude,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setMessage({ type: "success", text: "Usuario creado exitosamente" });
        setShowModal(false);
        setEmail("");
        setPassword("");
        setPaisCelular("MX");
        setPhoneNumber("");
        setNombresApellidos("");
        fetchUsers();
      } catch (error) {
        const errorMessage =
          error.response && error.response.data && error.response.data.error
            ? error.response.data.error
            : "No se pudo crear el usuario";

        // Mostrar el error específico en el campo correspondiente
        if (errorMessage.includes("correo")) {
          setEmailError(errorMessage);
        } else if (errorMessage.includes("celular")) {
          setPhoneError(errorMessage);
        } else if (errorMessage.includes("nombre")) {
          setNameError(errorMessage);
        } else {
          setMessage({ type: "error", text: errorMessage });
        }
        console.error("Error al crear el usuario", error);
        
      }
    } else {
      setMessage({
        type: "error",
        text: "No se pudo obtener la geolocalización.",
      });
      console.error("No se pudo obtener la geolocalización.");
    }

    setTimeout(() => {
      setMessage({ type: "", text: "" });
    }, 5000);
  };

  useEffect(() => {
    if (!showModal) {
      // Restablecer los campos del formulario y los errores cuando se cierra el modal
      setEmail("");
      setNombresApellidos("");
      setPaisCelular("MX");
      setPhoneNumber("");
      setEmailError("");
      setNameError("");
      setPhoneError("");
    }
  }, [showModal]);


  const actAsSeller = async (user) => {
    const tokenAdmin = localStorage.getItem("token");
    try {
      const response = await api.post(
        "/auth/actuar_como_vendedor",
        { vendedorId: user.UsuarioId },
        { headers: { Authorization: `Bearer ${tokenAdmin}` } }
      );

      localStorage.setItem("token_admin", tokenAdmin);
      localStorage.setItem("token", response.data.token_vendedor);

      updateUserRole(response.data.token_vendedor);

      setActingAsSeller(true);
      navigate("/vendedor/users");
    } catch (error) {
      console.error("Error al actuar como vendedor", error);
    }
  };

  // Exit editing mode when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setEditingIndex(null);
        setEditingSaldoIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredUsers = users.filter((user) => {
    const emailMatch = user.usuario.correo
      ? user.usuario.correo.toLowerCase().includes(searchTerm.toLowerCase())
      : false;
    const nameMatch = user.usuario.nombres_apellidos
      ? user.usuario.nombres_apellidos
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      : false;

    return emailMatch || nameMatch;
  });

  const handleSort = (field) => {
    const isAsc =
      sortedField.field === field && sortedField.direction === "asc";
    const direction = isAsc ? "desc" : "asc";
    setSortedField({ field, direction });
    setUsers(
      [...users].sort((a, b) => {
        if (field === "nombres_apellidos") {
          return direction === "asc"
            ? a.usuario.nombres_apellidos.localeCompare(b.usuario.nombres_apellidos)
            : b.usuario.nombres_apellidos.localeCompare(a.usuario.nombres_apellidos);
        } else if (field === "total_tiendas") {
          return direction === "asc" ? a.usuario.total_tiendas - b.usuario.total_tiendas : b.usuario.total_tiendas - a.usuario.total_tiendas;
        } else if (field === "valor_depositar") {
          return direction === "asc"
            ? a.usuario.valor_depositar.localeCompare(b.usuario.valor_depositar)
            : b.usuario.valor_depositar.localeCompare(a.usuario.valor_depositar);
        }
        return 0;
      })
    );
  };

  const handleOpenDeleteModal = (user) => {
    setUserToDelete(user);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
      const token = localStorage.getItem("token");
      console.log(userToDelete.id)
      try {
        await api.post(`/admin/eliminar-vendedor/${userToDelete.UsuarioId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setMessage({
          type: "success",
          text: "Tienda eliminados correctamente.",
        });
  
        setTimeout(() => {
          setMessage({ type: "", text: "" });
        }, 3000);
  
        setShowDeleteModal(false);
        fetchUsers();
      } catch (error) {
        setMessage({
          type: "error",
          text: "Error al eliminar la tienda y el usuario.",
        });
        setTimeout(() => {
          setMessage({ type: "", text: "" });
        }, 3000);
        console.error("Error al eliminar la tienda y el usuario:", error);
      }
    };

  const handleCloseModal = () => {
    setShowSuccessModal(false); // Cerrar el modal
    setModalMessage(""); // Vaciar el mensaje
  };
  
  return (
    <Container ref={containerRef}>
      <Row className="my-4">
        <Col>
          <h2 className="text-left" style={{ color: "#0A74DA" }}>
            Vendedores
          </h2>
        </Col>
        <Col className="text-right">
          <Button
            variant="primary"
            style={{ backgroundColor: "#0A74DA", color: "#fff" }}
            onClick={() => setShowModal(true)}
          >
          <FaPlus /> Nuevo
          </Button>
        </Col>
      </Row>

      {/*message.text && (
        <Alert variant={message.type === "success" ? "success" : "danger"}>
          {message.text}
        </Alert>
      )*/}

      <InputGroup className="mb-3">
        <FormControl
          placeholder="Buscar por vendedor o correo"
          onChange={handleSearch}
        />
      </InputGroup>

            {/* Ordenadores para móvil */}
            <Row className="my-1 d-block d-md-none">
<Col className="d-flex justify-content-center">
Ordenar por:
      </Col>
      <Col className="d-flex justify-content-center">
          <ButtonGroup className="mb-2">
            <Button
              variant="outline-secondary"
              onClick={() => handleSort("nombres_apellidos")}
            >
             Vendedor
            </Button>
            <Button
              variant="outline-secondary"
              onClick={() => handleSort("total_tiendas")}
            >
              Tiendas
            </Button>
            <Button
              variant="outline-secondary"
              onClick={() => handleSort("valor_depositar")}
            >
              Depósitos
            </Button>
          </ButtonGroup>
        </Col>
      </Row>

      {/* Desktop Table View */}
      <Table hover className="custom-table d-none d-md-table">
        <thead>
          <tr>
            <th>Vendedor</th>
            <th>Tiendas</th>
            <th>Historial</th>
            <th>Depósitos</th>
            <th>Depósitos recargas</th>
            <th>Saldo</th>
            <th>Congelar</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map((user, index) => (
            <tr key={index}>
              <td>
                <button
                  onClick={() => actAsSeller(user)}
                 
                  style={{
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    padding: 0,
                    color: '#0A74DA',
                    textAlign: "left", // Asegura que el texto se alinee a la izquierda
                    display: "block", // Evita que se centre cuando hay varias líneas
                    width: "100%", // Asegura que ocupe todo el espacio disponible
                  }}
                >
                  {user.usuario.nombres_apellidos}
                </button>
              </td>
              <td>{user.usuario.total_tiendas}</td>
              <td>
                <Button
                  variant="outline-primary"
                  style={{ marginTop: "-3px",padding: "5px 10px", fontSize: "14px", alignItems: "center"}}
                  onClick={() => navigate(`admin/historial/${user.usuario.id}`)}
                >
                  Historial
                </Button>
              </td>
              <td
                onClick={() => handleEditClick(index, "Deposito")}
                style={{ cursor: "pointer" }}
              >
                {editingIndex === index && editType === "Deposito" ? (
                  <FormControl
                    ref={inputRef}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9\-]*"
                    value={editableValue}
                    onChange={handleValueChange}
                    onKeyDown={(e) => handleValueKeyDown(e, user)}
                    autoFocus
                    placeholder="Ingrese valor"
                  />
                ) : (
                  <span>{user.usuario.valor_depositar.toFixed(2)}</span>
                )}
              </td>
              <td
                onClick={() => handleEditClick(index, "Recarga")}
                style={{ cursor: "pointer" }}
              >
                {editingIndex === index && editType === "Recarga" ? (
                  <FormControl
                    ref={inputRef}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9\-]*"
                    value={editableValue}
                    onChange={handleValueChange}
                    onKeyDown={(e) => handleValueKeyDown(e, user)}
                    autoFocus
                    placeholder="Ingrese valor"
                  />
                ) : (
                  <span>{user.credito.toFixed(2)}</span>
                )}
              </td>
              <td
                onClick={() => handleSaldoClick(index)}
                style={{ cursor: "pointer" }}
              >
                {editingSaldoIndex === index ? (
                  <FormControl
                    ref={inputRef}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9\-]*"
                    value={editableSaldoValue}
                    onChange={handleSaldoChange}
                    onKeyDown={(e) => handleSaldoKeyDown(e, user)}
                    autoFocus
		    placeholder="Ingrese valor"
                  />
                ) : (
                  <span>{user.saldo.toFixed(2)}</span>
                )}
              </td>
<td style={{ verticalAlign: "middle" }}>
                <ToggleSwitch
                  id={`activo-switch-${index}`}
                  checked={user.usuario.activo}
                  onChange={() => handleToggle(index, "activo")}
                
                />
              </td>
            <td>
  <ButtonGroup style={{ marginTop: "-7px", alignItems: "center" }}>
    {!user.usuario.eliminado && (
      <Tippy content="Eliminar" placement="top">
        <Button
          variant="link"
          style={{
            color: "red",
            fontSize: "18px",
            padding: "4px 6px",
            display: "flex",
            alignItems: "center",
          }}
          onClick={() => handleOpenDeleteModal(user)}
        >
          <FaTimes />
        </Button>
      </Tippy>
    )}

    <Tippy content="Configuración" placement="top">
      <Button
        variant="link"
        style={{
          fontSize: "18px",
          padding: "4px 6px",
          display: "flex",
          alignItems: "center",
        }}
        onClick={() => handleShowSaldoModal(user)}
      >
        <FaAddressBook />
      </Button>
    </Tippy>
  </ButtonGroup>
</td>

            </tr>
          ))}
        </tbody>
      </Table>

      {/* Mobile View Cards */}
      <div className="d-md-none user-cards">
        {filteredUsers.map((user, index) => (
          <div key={index} className="user-card">
            {/* Primera fila: Correo y Tiendas */}
            <div className="user-row" onClick={(e) => handleRowClick(e, index)}>
              <div className="user-detail left-align">
                <strong>Vendedor:</strong>
              </div>
              <div className="user-detail center-align">
                <strong>Tiendas:</strong>
              </div>
              <div className="user-detail right-align">
                <strong>Depósitos:</strong>
              </div>
            </div>

            <div className="user-row" onClick={(e) => handleRowClick(e, index)}>
              <div className="user-detail left-align">
              <span
    onClick={() => actAsSeller(user)}

      style={{
        cursor: "pointer",
        background: "none",
        border: "none",
        padding: 0,
        color: '#0A74DA',
        textAlign: "left", // Asegura que el texto se alinee a la izquierda
        display: "block", // Evita que se centre cuando hay varias líneas
        width: "100%", // Asegura que ocupe todo el espacio disponible
    }}
  >
    {user.usuario.nombres_apellidos}
  </span>
              </div>
              <div className="user-detail center-align">
              {user.usuario.total_tiendas}
              </div>
              <div className="user-detail right-align">
                           {/* Lógica para editar Depósitos */}
                           {editingIndex === index && editType === "Deposito" ? (
                  <FormControl
                    ref={inputRef}
                    type="text"
                    pattern="^-?(\d+)?(\.\d{0,2})?$"
      		    autoComplete="off"  // Deshabilitar autocompletar
      		    autoCorrect="off"   // Deshabilitar autocorrección
      		    spellCheck="false"  // Deshabilitar revisión ortográfica
                    value={editableValue}

                    onChange={(e) => handleValueChange(e)}
                    onKeyDown={(e) => handleValueKeyDown(e, user)}
                    autoFocus
                    placeholder="Ingrese valor"
                    onBlur={() => setEditingIndex(null)}

                  />

                ) : (
                  <span
                    onClick={() => handleEditClick(index, "Deposito")}
                    style={{ cursor: "pointer" }}
                  >
                    {user.usuario.valor_depositar.toFixed(2)}
                  </span>
                )}
              </div>
            </div>


                        {/* Primera fila: Correo y Tiendas */}


            {/* Segunda fila: Depósitos, Recargas y Saldo */}
            <div className="user-row" onClick={(e) => handleRowClick(e, index)}>
              <div className="user-detail left-align">
              <strong>Depósito Recargas:</strong>
              </div>
              <div className="user-detail center-align">
              <strong>Saldo:</strong>
              </div>
              <div className="user-detail right-align">
              <strong>Congelar:</strong>
              </div>
            </div>

            <div className="user-row" onClick={(e) => handleRowClick(e, index)}>
              <div className="user-detail left-align">
                {/* Lógica para editar Recargas */}
                {editingIndex === index && editType === "Recarga" ? (
                  <FormControl
                    ref={inputRef}
                    type="text"
                    pattern="^-?(\d+)?(\.\d{0,2})?$"
      		    autoComplete="off"  // Deshabilitar autocompletar
      		    autoCorrect="off"   // Deshabilitar autocorrección
      		    spellCheck="false"  // Deshabilitar revisión ortográfica
                    value={editableValue}
                    onChange={(e) => handleValueChange(e)}
                    onKeyDown={(e) => handleValueKeyDown(e, user)}
                    autoFocus
                    placeholder="Ingrese valor"
                    onBlur={() => setEditingIndex(null)}
                  />
                ) : (
                  <span
                    onClick={() => handleEditClick(index, "Recarga")}
                    style={{ cursor: "pointer" }}
                  >
                    {user.credito.toFixed(2)}
                  </span>
                )}              </div>
              <div className="user-detail center-align">
                {/* Lógica para editar Saldo */}
                {editingSaldoIndex === index ? (
                  <FormControl
                    ref={inputRef}
                    type="text"
                    pattern="^-?(\d+)?(\.\d{0,2})?$"
      		    autoComplete="off"  // Deshabilitar autocompletar
      		    autoCorrect="off"   // Deshabilitar autocorrección
      		    spellCheck="false"  // Deshabilitar revisión ortográfica
                    value={editableSaldoValue}
                    onChange={(e) => handleSaldoChange(e)}
                    onKeyDown={(e) => handleSaldoKeyDown(e, user)}
                    autoFocus
                   placeholder="Ingrese valor"
                    onBlur={() => setEditingSaldoIndex(null)}
                  />
                ) : (
                  <span
                    onClick={() => handleSaldoClick(index)}
                    style={{ cursor: "pointer" }}
                  >
                    {user.saldo.toFixed(2)}
                  </span>
                )}              </div>
              <div className="user-detail right-align">
              <ToggleSwitch
                    id={`activo-switch-${index}`}
                    checked={user.usuario.activo}
                    onChange={() => handleToggle(index, "activo")}
                  /> 
                  </div>
            </div>


            {/* Tercera fila: Historial, Activo, Configuración */}
            <div className="user-row">
              <div className="user-detail left-align">
                <Button
                  variant="outline-primary"
                  style={{ width: "110px",padding: "5px 5px", fontSize: "14px" }}
                  onClick={() => navigate(`admin/historial/${user.usuario.id}`)}
                >
                  Historial
                </Button>
              </div>
              <div className="user-detail center-align">
                         {!user.usuario.eliminado && (
                                <Button
                                  variant="outline-danger"
                                  onClick={() => handleOpenDeleteModal(user)}
                  style={{ width: "110px",padding: "5px 5px", fontSize: "14px" }}

                                >
                                  Eliminar
                                </Button>
                              )}
              </div>


               

              <div className="user-detail right-align">
                <Button
                  variant="outline-primary"
                  style={{ width: "110px",padding: "5px 5px", fontSize: "14px" }}
                  onClick={() => handleShowSaldoModal(user)}
                >
                  Configuración
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div></div>

      {/* Modal for Adding New User */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Nuevo Vendedor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formEmail">
              <Form.Label>Correo</Form.Label>
              <Form.Control
                type="email"
                placeholder="Ingresa el correo"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (validateEmail(e.target.value)) {
                    setEmailError("");
                  } else {
                    setEmailError("El correo electrónico no es válido");
                  }
                }}
                required
                isInvalid={!!emailError}
              />
              <Form.Control.Feedback type="invalid">
                {emailError}
              </Form.Control.Feedback>
            </Form.Group>
      <Form.Group controlId="formNombre">
  <Form.Label>Nombre</Form.Label>
  <Form.Control
    type="text"
    placeholder="Ingresa el nombre"
    value={nombres_apellidos}
    onChange={(e) => {
      const input = e.target.value;

      // No permitir más de 40 caracteres
      if (input.length > 40) {
        setNameError("El nombre no puede tener más de 40 caracteres.");
        return;
      }

      // No permitir más de 15 caracteres seguidos sin espacio
      if (/\S{16,}/.test(input)) {
        setNameError("No se permiten más de 15 caracteres seguidos sin espacio.");
        return;
      }

      // No permitir caracteres no válidos
      if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ ]*$/.test(input)) {
        setNameError("El nombre solo puede contener letras y espacios.");
        return;
      }

      // Si pasa todas las validaciones, actualiza el estado y limpia error
      setNombresApellidos(input);
      setNameError("");
    }}
    required
    isInvalid={!!nameError}
  />
  <Form.Control.Feedback type="invalid">
    {nameError}
  </Form.Control.Feedback>
</Form.Group>

            <Form.Group controlId="formPhoneNumber">
              <Form.Label>Número de WhatsApp</Form.Label>
              <CampoCelular
                pais={paisCelular}
                onPaisChange={setPaisCelular}
                numero={phoneNumber}
                onNumeroChange={(valor) => { setPhoneNumber(valor); setPhoneError(""); }}
                error={phoneError}
                onEnter={handleCreateUser}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            style={{ backgroundColor: "#0A74DA", color: "#fff" }}
            onClick={handleCreateUser}
          >
            Crear Usuario
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal para editar los datos */}
      <Modal show={showSaldoModal} onHide={handleCloseSaldoModal}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Datos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {message.text && (
        <Alert variant={message.type === "success" ? "success" : "danger"}>
          {message.text}
        </Alert>
      )}

          {selectedUser ? (
            <> 
 <div>
 <form onSubmit={(e) => { e.preventDefault(); handleEmailSubmit(); }}>

                <Form.Group controlId="formCorreo" className="mb-3">
                <Form.Label>Correo</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="email"
                    value={editedEmail}
                    onChange={handleEmailChange}
                    isInvalid={!!emailError}
                    enterKeyHint="done" // Para forzar que se muestre "Enter" o "Done"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleEmailSubmit();
                        e.target.blur();
                      }
                    }}
                  />
                  <Button variant="primary" onClick={handleEmailSubmit}>
                    <FaArrowRight />
                  </Button>
                  <Form.Control.Feedback type="invalid">
                    {emailError}
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
              </form>

              </div>

               <div>
               <form onSubmit={(e) => { e.preventDefault(); handleEmailSubmit(); }}>

              <Form.Group controlId="formUsuarioPorcentaje" className="mb-3">
                <Form.Label>Porcentaje por venta (0 - 2)</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="number"
                    value={editedUsuarioPorcentaje}
                    onChange={handleUsuarioPorcentajeChange}
                    isInvalid={!!usuarioPorcentajeError}
                    enterKeyHint="done" // Para forzar que se muestre "Enter" o "Done"

                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleUsuarioPorcentajeSubmit();
                        e.target.blur();
                      }
                    }}
                  />{" "}
                  <Button
                    variant="primary"
                    onClick={handleUsuarioPorcentajeSubmit}
                  >
                    <FaArrowRight />
                  </Button>
                  <Form.Control.Feedback type="invalid">
                    {usuarioPorcentajeError}
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
              </form>

              </div>
              <div>
              <form onSubmit={(e) => { e.preventDefault(); handleEmailSubmit(); }}>

              <Form.Group controlId="formPorcentaje" className="mb-3">
                <Form.Label>Porcentaje recargas personales (0 - 7)</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="number"
                    value={editedPorcentaje}
                    onChange={handlePorcentajeChange}
                    isInvalid={!!porcentajeError}
                    enterKeyHint="done" // Para forzar que se muestre "Enter" o "Done"

                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handlePorcentajeSubmit();
                        e.target.blur();
                      }
                    }}
                  />
                  <Button variant="primary" onClick={handlePorcentajeSubmit}>
                    <FaArrowRight />
                  </Button>
                  <Form.Control.Feedback type="invalid">
                    {porcentajeError}
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
              </form>
              </div>
               </> 
          ) : (
            <p>Cargando detalles...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseSaldoModal}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

                    {/* Modal de éxito */}
                    <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Body className="text-center">
          <div>{modalMessage}</div>
          <button
            className="close-button"
            onClick={() => handleCloseModal()} // Permitir cerrar con la X
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              border: "none",
              background: "transparent",
            }}
          >
            <FaTimes size={20} />
          </button>
        </Modal.Body>
      </Modal>

      {/* Modal de Confirmación de Eliminación */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Confirmar Eliminación</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {userToDelete
                  ? `¿Estás seguro de eliminar ${userToDelete.usuario.nombres_apellidos}?`
                  : ""}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                  Cancelar
                </Button>
                <Button variant="danger" onClick={handleDelete}>
                  Eliminar
                </Button>
              </Modal.Footer>
            </Modal>
      

      

      <style>{`
  .user-cards {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  .user-card {
    padding: 10px 0;
    border-bottom: 1px solid #ddd;
    background-color: #fff;
    transition: background-color 0.3s ease;
    align-items: center; /* Centra verticalmente los elementos */

  }
 .user-row {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
   /* align-items: center;  Centra verticalmente los elementos */
  }
  .user-detail {
    flex: 1;
  }
  .left-align {
    text-align: left;
  }
  .center-align {
    text-align: center;
  }
  .right-align {
    text-align: right;
  }
    .user-detail.correo {
    flex: 2; /* 'Correo' ocupa 2 partes del espacio */
  }
  .user-detail.tiendas {
    flex: 1; /* 'Tiendas' ocupa 1 parte del espacio */
  }
    .activo-container {
  display: flex;
    flex-direction: row;
    align-items: left;
  }

    .activo-container .switch {
  margin-top: 3px; /* Ajusta este valor según sea necesario */
}
`}</style>
    </Container>
  );
};

export default ManageSellers;
